// Everything shown to the user is Singapore time (SGT, UTC+8, no DST) — the
// business runs in Singapore and the sync rules are defined in SGT. Timestamps
// arrive either as ISO-8601 (with 'Z') or as SQLite's zone-less
// "YYYY-MM-DD HH:MM:SS" (which is UTC); both are pinned to UTC before formatting.

const SGT = "Asia/Singapore";

const dateTimeFmt = new Intl.DateTimeFormat("en-GB", {
  timeZone: SGT,
  day: "2-digit",
  month: "short",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hour12: false,
});

function toDate(s: string | number): Date {
  if (typeof s === "number") return new Date(s);
  const iso = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(s)
    ? `${s.replace(" ", "T")}Z`
    : s;
  return new Date(iso);
}

const dateFmt = new Intl.DateTimeFormat("en-CA", {
  timeZone: SGT,
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

/**
 * Today's SGT calendar date as `YYYY-MM-DD` — the same basis the server uses to
 * decide whether an allowlist entry has expired, so the UI agrees with it even
 * when the viewer's browser is in another timezone.
 */
export function sgtToday(now: Date = new Date()): string {
  return dateFmt.format(now); // en-CA → "YYYY-MM-DD"
}

/** "DD Mon YYYY HH:MM:SS SGT" for an ISO string, SQLite timestamp, or epoch ms. */
export function fmtSgtDateTime(s: string | number | null | undefined): string {
  if (s === null || s === undefined || s === "") return "—";
  const d = toDate(s);
  if (Number.isNaN(d.getTime())) return String(s);
  return `${dateTimeFmt.format(d).replace(",", "")} SGT`;
}
